import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-downtown-los-angeles')!;

const DTLAPage = () => <CityLandingPage data={data} />;

export default DTLAPage;
